import {Mode, Skin} from "@webbyx/mui";

import {textPrimaryColor, textSecondaryColor} from '../../config/colors';

export const createThemeOverrideDialogContentText = (mode: Mode, skin: Skin) => {
  return {
    MuiDialogContentText: {
      defaultProps: {
        color: 'secondary' as any
      },
      variants: [
        {
          props: { color: 'primary' as any },
          style: {
            color: textPrimaryColor,
          },
        },
        {
          props: { color: 'secondary' as any },
          style: {
            color: textSecondaryColor,
          },
        },
      ]
    }
  }
}

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default createThemeOverrideDialogContentText;
